module.exports = __webpack_public_path__ + "static/img/CUP0048999_rgb.031e4c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/CUP0048999_rgb.jpg
// module id = 3VmZ
// module chunks = 0